import React, {createContext, useContext} from "react";
import DataSource from "./DataSource";
import {updateExtensionProfileDataFieldDescriptor} from "./fieldDescriptors";
import {UpdateExtensionProfileField} from "./types";

export type ReorderFunc = (dragIndex: number, hoverIndex: number) => void;

export const DataSourceContext = createContext(undefined);
export const useDataSource = () => useContext(DataSourceContext) as DataSource;

export const RestrictedModeContext: React.Context<boolean> = createContext(false);
export const useRestrictedModeValue = () => useContext(RestrictedModeContext);
export const useRestrictedDisabled = (field: UpdateExtensionProfileField, disabled: boolean) => {
    const isRestrictedMode = useRestrictedModeValue();
    const dataSource = useDataSource();
    const restriction = updateExtensionProfileDataFieldDescriptor[field].restriction;

    if (disabled || !isRestrictedMode || !restriction) return disabled;

    const restrictions = dataSource.data.current.extension.featuresRestrictions;

    return restrictions.includes(restriction);
};
